import projects from './projects'
import enterprises from './enterprises'

export default {
  projects,
  enterprises
}



// WEBPACK FOOTER //
// ./src/api/millionsProject/index.js